import { SUBMENU_DEFAULT_VALUE } from '../../../constants/route'
import { getFilesBreadcrumbs } from '../../File'

import { getEntityTabDocumentsFieldApi } from './EntityTabDocuments.api'

export function getEntityTabDocumentsDownloadApiParams({ objectId, scope }) {
  return { object_id: objectId, scope }
}

export function getEntityTabDocumentsParent({ filterValues, rootDirectoryId }) {
  const parent = filterValues?.parent ?? rootDirectoryId

  return parent != null ? String(parent) : undefined
}

export function getEntityTabDocumentsFilterBarApiUrl({
  filterValues,
  getFilterBarApiUrl,
  objectId,
  outboundUuid,
  rootDirectoryId,
  scope,
  sub = SUBMENU_DEFAULT_VALUE,
}) {
  const parent = filterValues?.parent || rootDirectoryId

  const getApiUrl = getFilterBarApiUrl || getEntityTabDocumentsFieldApi

  return getApiUrl({
    objectId,
    outboundUuid,
    parent,
    scope,
    sub,
  })
}

export function getEntityTabDocumentsBreadcrumbs({
  breadcrumbRootItems,
  breadcrumbStorageItemId,
  handleSetParent,
  items,
  rootDirectoryId,
  t,
}) {
  const rootWithClick = breadcrumbRootItems.map(item => {
    if (
      breadcrumbStorageItemId != null &&
      item.id === breadcrumbStorageItemId
    ) {
      return {
        ...item,
        onClick: () => handleSetParent(rootDirectoryId),
      }
    }

    return item
  })

  const pathBreadcrumbs = getFilesBreadcrumbs({
    handleClickOption: id => handleSetParent(id),
    path: items?.parent?.path,
    t,
  })

  const rootIndex = pathBreadcrumbs.findIndex(
    item => String(item?.id) === String(rootDirectoryId)
  )

  const filteredPathBreadcrumbs =
    rootIndex >= 0 ? pathBreadcrumbs.slice(rootIndex + 1) : pathBreadcrumbs

  return [...rootWithClick, ...filteredPathBreadcrumbs]
}
